import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";
import _ from "lodash";

import WrapperContainer from "../components/WrapperContainer/WrapperContainer.jsx";
import Button from "../components/Button/Button.jsx";

import Input from "../components/Input/Input.jsx";
import { APP_ROUTES } from "../router";

import { useFormFeedback } from "../hooks/useFormFeedback.js";
import handleNotify from "../utils/helpers/handleNotify.js";

import actions from "../store/actions.js";

/**
 * Компонент, отображаемый в случае возникновения ошибки при взаимодействии с API
 */
const Error = () => {
  const history = useNavigate();
  const { mobileConnectionInfo } = useSelector(state => state);

  // TODO: upgrade to RHF
  const [userName, setUserName] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState("");

  const [userAddress, setUserAddress] = useState("");
  const [userComment, setUserComment] = useState("");

  const { sendFormFeedback } = useFormFeedback();
  const dispatch = useDispatch();

  // Если в браузере есть данные о пользователе, то устанавливаем их в поля ввода формы
  useEffect(() => {
    const { fullName, phoneNumber } = mobileConnectionInfo;

    if (!_.isEmpty(mobileConnectionInfo)) {
      setUserName(fullName);
      setUserPhoneNumber(phoneNumber);

      const address = getContractAddress();
      setUserAddress(address);
    }
  }, []);

  /**
   * Получить полный адрес по договору
   *
   * @return {String}
   */
  const getContractAddress = () => {
    const { city, street, house, flat } = mobileConnectionInfo;

    if (!city || !street || !house) return "";

    return `${city.title}, ${street.title}, ${house.house}${house?.frac || ""}${
      flat ? `, кв.${flat}` : ""
    }`;
  };

  const sendDataFeedback = async () => {
    try {
      await sendFormFeedback(
        userName,
        userPhoneNumber,
        userAddress,
        mobileConnectionInfo.initialUrl,
        userComment
      );

      handleNotify(
        "success",
        null,
        "Заявка на обратный звонок отправлена. Ожидайте звонка оператора"
      );

      dispatch(actions.removeData());
      history(APP_ROUTES.MOBILE_CONNECTION.ROOT_ROUTE);
    } catch (error) {
      handleNotify("error", error);
    }
  };

  const isFillRequiredFields = userName && userPhoneNumber && userAddress;

  return (
    <>
      <WrapperContainer gap="16" title="sm">
        Что-то пошло не так...
      </WrapperContainer>

      <WrapperContainer gap="24" text="lg">
        Оставьте заявку, с Вами свяжется наш менеджер и проконсультирует.
      </WrapperContainer>

      <form onSubmit={event => event.preventDefault()}>
        <WrapperContainer gap="16">
          <Input
            placeholder="ФИО"
            onChange={event => setUserName(event.target.value)}
            value={userName}
          />
        </WrapperContainer>

        <WrapperContainer gap="16">
          <Input
            type="tel"
            placeholder="Номер телефона"
            onChange={event => setUserPhoneNumber(event.target.value)}
            value={userPhoneNumber}
          />
        </WrapperContainer>

        <WrapperContainer gap="16">
          <Input
            placeholder="Адрес"
            onChange={event => setUserAddress(event.target.value)}
            value={userAddress}
          />
        </WrapperContainer>

        <WrapperContainer gap="24">
          <textarea
            className="textarea"
            placeholder="Комментарий"
            onChange={event => setUserComment(event.target.value)}
            value={userComment}
            rows={3}
          />
        </WrapperContainer>

        <Button
          isSubmit
          isStretch
          color="primary"
          size="xl"
          onClick={sendDataFeedback}
          disabled={!isFillRequiredFields}
        >
          Оставить заявку
        </Button>
      </form>
    </>
  );
};

export default Error;
